import React, { useEffect } from 'react'
import {Helmet}from"react-helmet";
import f1 from './ff1.pdf';
import ff2 from './ff2.pdf';
import ff3 from './ff3.pdf';
import '../components/Styles/inv.css'
import '../components/Styles/res.css'
import AOS from 'aos';
import 'aos/dist/aos.css';


const Resources = () => {
    useEffect(()=>{
        AOS.init();
       
      })
    
  return (
    <div>
         <Helmet>
       <title>Resources - 33 Percent Fund</title>
      <meta name="description" content="Discover Winning Investment Strategies for Financial Success | Your Path to Wealth Begins Here! Explore Proven Investment Strategies to Maximize Returns and minimize Risks."/>
      < meta name="viewport" content="width=device-width, initial-scale=1.0"/>
      <meta charset="UTF-8"/>
      </Helmet>
        <section className='about__us_main' >
          <h1 data-aos="zoom-in">Focus Sub Fund</h1>
         </section>
<br/><br/><br/><br/>
       <section className='invest_centerb'>
        <div className='res_row'>
          <div className='res_col'>
               <h2>Focus Fund Systematic, AI-Powered Market-Neutral Strategy

               </h2>
          </div>
          <div className='res_col'>
            <div className='ress'>
            <a  href = {f1} target = "_blank">Download &nbsp;<i class="ri-download-fill"></i></a>
            </div>
         </div>
        </div>
        <br/><br/>


        <div  className='res_row'>
          <div className='res_col'>
               <h2>Paul Glance – Strategy Track Record Summary
               </h2>
          </div>
          <div className='res_col'>
            <div className='ress'>
            <a  href = {ff2} target = "_blank">Download &nbsp;<i class="ri-download-fill"></i></a>
            </div>
         </div>
        </div>
   <br/>
<div  className='res_row'>
          <div className='res_col'>
               <h2>Focus Fund – Institutional Tear Sheet

               </h2>
          </div>
          <div className='res_col'>
            <div className='ress'>
            <a  href = {ff3} target = "_blank">Download &nbsp;<i class="ri-download-fill"></i></a>
            </div>
         </div>
        </div>

<br/><br/>
 
       </section>

    </div>
  )
}

export default Resources;